import axiosInstance from './axios';

export const getVendorProfile = async () => {
  try {
    const res = await axiosInstance.get("/vendors/profile");
    return res.data;
  } catch (err) {
    if (err?.response?.status === 401) {
      return null;
    }
    throw err;
  }
};

export const updateVendorProfile = async (payload) => {
  const res = await axiosInstance.patch('/vendors/profile', payload);
  return res.data?.data || res.data;
};

export const getVendorBillingProfile = async () => {
  const res = await axiosInstance.get('/vendors/billing-profile');
  return res.data?.data || res.data;
};

export const updateVendorBillingProfile = async (payload) => {
  const res = await axiosInstance.patch('/vendors/billing-profile', payload);
  return res.data?.data || res.data;
};

export const uploadVendorBillingDocument = async ({ file, documentType }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('documentType', documentType || 'TAX_REGISTRATION');

  const res = await axiosInstance.post('/vendors/billing-profile/documents', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data?.data || res.data;
};

export const getVendorBillingDocuments = async () => {
  const res = await axiosInstance.get('/vendors/billing-profile/documents');
  return res.data?.data || res.data;
};

export const getVendorLaunchReadiness = async () => {
  const res = await axiosInstance.get('/vendors/launch-readiness');
  return res.data?.data || res.data;
};

export const requestVendorGoLive = async () => {
  const res = await axiosInstance.post('/vendors/launch-request');
  return res.data?.data || res.data;
};

export const verifyWidgetInstallation = async (payload) => {
  const res = await axiosInstance.post('/vendors/widget-installation/verify', payload);
  return res.data;
};

export const getDomainVerification = async () => {
  const res = await axiosInstance.get('/vendors/domain-verification');
  return res.data?.data || res.data;
};

export const verifyDomainOwnership = async (payload) => {
  const res = await axiosInstance.post('/vendors/domain-verification/verify', payload);
  return res.data?.data || res.data;
};

export const recheckDomainOwnership = async () => {
  const res = await axiosInstance.post('/vendors/domain-verification/recheck');
  return res.data?.data || res.data;
};

export const addOrganizationDomain = async (payload) => {
  const res = await axiosInstance.post('/vendors/domain-verification/domains', payload);
  return res.data?.data || res.data;
};

export const verifyOrganizationDomain = async (domainId) => {
  const res = await axiosInstance.post(`/vendors/domain-verification/domains/${domainId}/verify`);
  return res.data?.data || res.data;
};

export const recheckOrganizationDomain = async (domainId) => {
  const res = await axiosInstance.post(`/vendors/domain-verification/domains/${domainId}/recheck`);
  return res.data?.data || res.data;
};

export const deleteOrganizationDomain = async (domainId) => {
  const res = await axiosInstance.delete(`/vendors/domain-verification/domains/${domainId}`);
  return res.data?.data || res.data;
};

export const getVendorChannels = async () => {
  const res = await axiosInstance.get('/vendors/channels');
  return res.data?.data || res.data;
};

export const testVendorWhatsAppConnection = async (payload = {}) => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/test', payload);
  return res.data?.data || res.data;
};

export const registerVendorWhatsAppCloudApi = async (payload = {}) => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/register-cloud-api', payload);
  return res.data?.data || res.data;
};

export const syncVendorWhatsAppCloudApi = async (payload = {}) => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/sync-cloud-api', payload);
  return res.data?.data || res.data;
};

export const disconnectVendorWhatsApp = async (payload = {}) => {
  if (payload.channelId) {
    const res = await axiosInstance.delete(`/vendors/channels/whatsapp/${payload.channelId}`);
    return res.data?.data || res.data;
  }
  const res = await axiosInstance.post('/vendors/channels/whatsapp/disconnect', payload);
  return res.data?.data || res.data;
};

export const setDefaultVendorWhatsAppNumber = async (payload = {}) => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/default', payload);
  return res.data?.data || res.data;
};

export const getVendorServices = async () => {
  const res = await axiosInstance.get('/vendors/services');
  return res.data?.data || res.data;
};

export const activateVendorService = async (code) => {
  const res = await axiosInstance.post(`/vendors/services/${code}/activate`);
  return res.data?.data || res.data;
};

export const deactivateVendorService = async (code) => {
  const res = await axiosInstance.post(`/vendors/services/${code}/deactivate`);
  return res.data?.data || res.data;
};

export const getWhatsAppTemplates = async () => {
  const res = await axiosInstance.get('/vendors/channels/whatsapp/templates');
  return res.data?.data || res.data;
};

export const createWhatsAppTemplate = async (payload) => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/templates', payload);
  return res.data?.data || res.data;
};

export const updateWhatsAppTemplate = async (templateId, payload) => {
  const res = await axiosInstance.patch(`/vendors/channels/whatsapp/templates/${templateId}`, payload);
  return res.data?.data || res.data;
};

export const syncWhatsAppTemplates = async () => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/templates/sync');
  return res.data?.data || res.data;
};

export const deleteWhatsAppTemplate = async (templateId) => {
  const res = await axiosInstance.delete(`/vendors/channels/whatsapp/templates/${templateId}`);
  return res.data?.data || res.data;
};

export const getDeveloperApiKeys = async () => {
  const res = await axiosInstance.get('/vendors/developer-api/keys');
  return res.data?.data || res.data;
};

export const createDeveloperApiKey = async (payload) => {
  const res = await axiosInstance.post('/vendors/developer-api/keys', payload);
  return res.data?.data || res.data;
};

export const revokeDeveloperApiKey = async (keyId) => {
  const res = await axiosInstance.delete(`/vendors/developer-api/keys/${keyId}`);
  return res.data?.data || res.data;
};

export const getDeveloperWebhooks = async () => {
  const res = await axiosInstance.get('/vendors/developer-api/webhooks');
  return res.data?.data || res.data;
};

export const createDeveloperWebhook = async (payload) => {
  const res = await axiosInstance.post('/vendors/developer-api/webhooks', payload);
  return res.data?.data || res.data;
};

export const updateDeveloperWebhook = async (webhookId, payload) => {
  const res = await axiosInstance.patch(`/vendors/developer-api/webhooks/${webhookId}`, payload);
  return res.data?.data || res.data;
};

export const rotateDeveloperWebhookSecret = async (webhookId) => {
  const res = await axiosInstance.post(`/vendors/developer-api/webhooks/${webhookId}/rotate-secret`);
  return res.data?.data || res.data;
};

export const getWhatsAppCampaigns = async () => {
  const res = await axiosInstance.get('/vendors/channels/whatsapp/campaigns');
  return res.data?.data || res.data;
};

export const createWhatsAppCampaign = async (payload) => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/campaigns', payload);
  return res.data?.data || res.data;
};

export const cancelWhatsAppCampaign = async (campaignId) => {
  const res = await axiosInstance.patch(`/vendors/channels/whatsapp/campaigns/${campaignId}/cancel`);
  return res.data?.data || res.data;
};

export const deleteWhatsAppCampaign = async (campaignId) => {
  const res = await axiosInstance.delete(`/vendors/channels/whatsapp/campaigns/${campaignId}`);
  return res.data?.data || res.data;
};

export const getWhatsAppFlows = async () => {
  const res = await axiosInstance.get('/vendors/channels/whatsapp/flows');
  return res.data?.data || res.data;
};

export const createWhatsAppFlow = async (payload) => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/flows', payload);
  return res.data?.data || res.data;
};

export const updateWhatsAppFlow = async (flowId, payload) => {
  const res = await axiosInstance.patch(`/vendors/channels/whatsapp/flows/${flowId}`, payload);
  return res.data?.data || res.data;
};

export const publishWhatsAppFlow = async (flowId) => {
  const res = await axiosInstance.post(`/vendors/channels/whatsapp/flows/${flowId}/publish`);
  return res.data?.data || res.data;
};

export const archiveWhatsAppFlow = async (flowId) => {
  const res = await axiosInstance.delete(`/vendors/channels/whatsapp/flows/${flowId}`);
  return res.data?.data || res.data;
};

export const getWhatsAppAutomations = async () => {
  const res = await axiosInstance.get('/vendors/channels/whatsapp/automations');
  return res.data?.data || res.data;
};

export const saveWhatsAppAutomations = async (payload) => {
  const res = await axiosInstance.put('/vendors/channels/whatsapp/automations', payload);
  return res.data?.data || res.data;
};

export const syncWhatsAppAutomationsToMeta = async () => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/automations/sync-meta');
  return res.data?.data || res.data;
};

export const getWhatsAppAdsOverview = async () => {
  const res = await axiosInstance.get('/vendors/channels/whatsapp/ads');
  return res.data?.data || res.data;
};

export const syncWhatsAppAdAccounts = async () => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/ads/accounts/sync');
  return res.data?.data || res.data;
};

export const selectWhatsAppAdAccount = async (accountId) => {
  const res = await axiosInstance.post(`/vendors/channels/whatsapp/ads/accounts/${accountId}/select`);
  return res.data?.data || res.data;
};

export const syncWhatsAppAdPages = async () => {
  const res = await axiosInstance.post('/vendors/channels/whatsapp/ads/pages/sync');
  return res.data?.data || res.data;
};

export const syncWhatsAppAdCampaigns = async ({ adAccountId, days = 30 } = {}) => {
  const res = await axiosInstance.post(
    `/vendors/channels/whatsapp/ads/campaigns/sync?days=${encodeURIComponent(days)}`,
    { adAccountId },
  );
  return res.data?.data || res.data;
};

export const createWhatsAppAdCampaign = async (payload) => {
  if (payload?.mediaFile) {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      if (key === 'mediaFile') {
        formData.append('image', value);
        return;
      }
      formData.append(key, String(value));
    });
    const res = await axiosInstance.post('/vendors/channels/whatsapp/ads/campaigns/create-with-image', formData);
    return res.data?.data || res.data;
  }
  const res = await axiosInstance.post('/vendors/channels/whatsapp/ads/campaigns/create', payload);
  return res.data?.data || res.data;
};

export const getEmailMarketingOverview = async () => {
  const res = await axiosInstance.get('/vendors/email-marketing');
  return res.data?.data || res.data;
};

export const updateEmailMarketingSettings = async (payload) => {
  const res = await axiosInstance.patch('/vendors/email-marketing/settings', payload);
  return res.data?.data || res.data;
};

export const checkEmailMarketingDomain = async () => {
  const res = await axiosInstance.post('/vendors/email-marketing/settings/check-domain');
  return res.data?.data || res.data;
};

export const sendEmailMarketingTestEmail = async (payload) => {
  const res = await axiosInstance.post('/vendors/email-marketing/settings/test-email', payload);
  return res.data?.data || res.data;
};

export const rotateEmailMarketingWebhookSecret = async () => {
  const res = await axiosInstance.post('/vendors/email-marketing/settings/delivery-webhook-secret');
  return res.data?.data || res.data;
};

export const addEmailSubscriber = async (payload) => {
  const res = await axiosInstance.post('/vendors/email-marketing/subscribers', payload);
  return res.data?.data || res.data;
};

export const importEmailSubscribers = async ({ file, consentSource, consentProof, consentDeclarationAccepted }) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('consentSource', consentSource || '');
  formData.append('consentProof', consentProof || '');
  formData.append('consentDeclarationAccepted', consentDeclarationAccepted ? 'true' : 'false');
  const res = await axiosInstance.post('/vendors/email-marketing/subscribers/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data?.data || res.data;
};

export const getEmailSuppressions = async () => {
  const res = await axiosInstance.get('/vendors/email-marketing/suppressions');
  return res.data?.data || res.data;
};

export const addEmailSuppression = async (payload) => {
  const res = await axiosInstance.post('/vendors/email-marketing/suppressions', payload);
  return res.data?.data || res.data;
};

export const unsubscribeEmailSubscriber = async (subscriberId) => {
  const res = await axiosInstance.patch(`/vendors/email-marketing/subscribers/${subscriberId}/unsubscribe`);
  return res.data?.data || res.data;
};

export const resendEmailSubscriberConfirmation = async (subscriberId) => {
  const res = await axiosInstance.post(`/vendors/email-marketing/subscribers/${subscriberId}/resend-confirmation`);
  return res.data?.data || res.data;
};

export const createEmailCampaign = async (payload) => {
  const res = await axiosInstance.post('/vendors/email-marketing/campaigns', payload);
  return res.data?.data || res.data;
};

export const getEmailCampaignTemplates = async () => {
  const res = await axiosInstance.get('/vendors/email-marketing/campaigns/templates');
  return res.data?.data || res.data;
};

export const saveEmailCampaignTemplate = async (payload) => {
  const res = await axiosInstance.post('/vendors/email-marketing/campaigns/templates/custom', payload);
  return res.data?.data || res.data;
};

export const deleteEmailCampaignTemplate = async (templateKey) => {
  const templateId = String(templateKey || '').replace(/^custom:/, '');
  const res = await axiosInstance.delete(`/vendors/email-marketing/campaigns/templates/custom/${templateId}`);
  return res.data?.data || res.data;
};

export const createEmailCampaignFromTemplate = async (templateKey, payload = {}) => {
  const res = await axiosInstance.post(`/vendors/email-marketing/campaigns/templates/${templateKey}`, payload);
  return res.data?.data || res.data;
};

export const updateEmailCampaign = async (campaignId, payload) => {
  const res = await axiosInstance.patch(`/vendors/email-marketing/campaigns/${campaignId}`, payload);
  return res.data?.data || res.data;
};

export const archiveEmailCampaign = async (campaignId) => {
  const res = await axiosInstance.delete(`/vendors/email-marketing/campaigns/${campaignId}`);
  return res.data?.data || res.data;
};

export const markEmailCampaignReady = async (campaignId) => {
  const res = await axiosInstance.post(`/vendors/email-marketing/campaigns/${campaignId}/ready`);
  return res.data?.data || res.data;
};

export const scheduleEmailCampaign = async (campaignId, payload) => {
  const res = await axiosInstance.post(`/vendors/email-marketing/campaigns/${campaignId}/schedule`, payload);
  return res.data?.data || res.data;
};

export const sendEmailCampaign = async (campaignId) => {
  const res = await axiosInstance.post(`/vendors/email-marketing/campaigns/${campaignId}/send`);
  return res.data?.data || res.data;
};

export const getEmailCampaignAudience = async (campaignId) => {
  const res = await axiosInstance.get(`/vendors/email-marketing/campaigns/${campaignId}/audience`);
  return res.data?.data || res.data;
};

export const getEmailCampaignDeliveries = async (campaignId) => {
  const res = await axiosInstance.get(`/vendors/email-marketing/campaigns/${campaignId}/deliveries`);
  return res.data?.data || res.data;
};

export const getVendorRuntimeStatus = async () => {
  const res = await axiosInstance.get('/vendors/runtime-status');
  return res.data?.data || res.data;
};

export const getVendorTeamMembers = async () => {
  const res = await axiosInstance.get('/vendors/users');
  return res.data?.data || res.data;
};

export const getVendorActivity = async (filters = {}) => {
  const res = await axiosInstance.get('/vendors/activity', {
    params: {
      limit: filters.limit || 30,
      category: filters.category && filters.category !== 'ALL' ? filters.category : undefined,
      action: filters.action && filters.action !== 'ALL' ? filters.action : undefined,
      search: filters.search || undefined,
      from: filters.from || undefined,
      to: filters.to || undefined,
    },
  });
  return res.data?.data || res.data;
};

export const inviteVendorTeamMember = async (payload) => {
  const res = await axiosInstance.post('/vendors/users', payload);
  return res.data?.data || res.data;
};

export const updateVendorTeamMember = async (memberId, payload) => {
  const res = await axiosInstance.patch(`/vendors/users/${memberId}`, payload);
  return res.data?.data || res.data;
};

export const resetVendorTeamMemberPassword = async (memberId) => {
  const res = await axiosInstance.post(`/vendors/users/${memberId}/reset-password`);
  return res.data?.data || res.data;
};

export const removeVendorTeamMember = async (memberId) => {
  const res = await axiosInstance.delete(`/vendors/users/${memberId}`);
  return res.data?.data || res.data;
};

export const startWidgetLaunchTest = async ({ vendorId, attribution }) => {
  const res = await axiosInstance.post('/widget/start', {
    vendorId,
    attribution,
  });
  return res.data?.data || res.data;
};

export const sendWidgetLaunchTestMessage = async ({ vendorId, conversationId, content, attribution }) => {
  const res = await axiosInstance.post('/widget/message', {
    vendorId,
    conversationId,
    content,
    attribution,
  });
  return res.data?.data || res.data;
};

export const getLaunchTestMessages = async ({ vendorId, conversationId }) => {
  const res = await axiosInstance.get(`/vendors/${vendorId}/conversations/${conversationId}/messages`);
  return res.data?.data || res.data;
};
